import { useGetPlaylists } from './useGetPlaylists'

export const useCheckIsDuplicatedTitle = () => {
  const { playlists } = useGetPlaylists()
  const checkIsDuplicated = (title: string) => {
    return playlists.some((playlist) => playlist.title === title)
  }
  return { checkIsDuplicated }
}
